import { environment } from '../environments/environment';
import { Routes } from '@angular/router';
import authRoutes from './features/auth/routes';
import occupationsRoutes from './features/occupations/routes';
import { LayoutComponent } from './core/layout/layout.component';
import { MsalGuard } from '@azure/msal-angular';
import employeesRoutes from './features/employees/routes';
import insuranceTypesRoutes from './features/insurance-types/routes';
import banksRoutes from './features/banks/routes';
import coveragesRoutes from './features/coverages/routes';
import parametersRoutes from './features/parameters/routes';

import { retailerGuard } from './core/guards/retailer.guard';
import { superuserGuard } from './core/guards/superuser.guard';
import { bankAdminGuard } from './core/guards/bank-admin.guard';
import directorsRoutes from './features/directors/routes';
import { NoAccessComponent } from './features/auth/ui/no-access/no-access.component';

export const routes: Routes = [
  ...authRoutes,
  {
    path: 'no-access',
    component: NoAccessComponent,
  },
  {
    path: '',
    // Dev impersonation replaces the B2C sign-in, so MsalGuard would block every route
    canActivate: environment.devAuth?.enabled ? [retailerGuard] : [MsalGuard, retailerGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'employees',
        pathMatch: 'full',
      },
      ...employeesRoutes,
      ...insuranceTypesRoutes,
      // Global directors manage their own bank's branches and regions
      ...banksRoutes.map(route => ({
        ...route,
        canActivate: [bankAdminGuard],
      })),
      ...directorsRoutes.map(route => ({
        ...route,
        canActivate: [bankAdminGuard],
      })),
      ...occupationsRoutes.map(route => ({
        ...route,
        canActivate: [superuserGuard],
      })),
      ...coveragesRoutes.map(route => ({
        ...route,
        canActivate: [superuserGuard],
      })),
      ...parametersRoutes.map(route => ({
        ...route,
        canActivate: [superuserGuard],
      })),
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
